import { Box } from "@chakra-ui/react";
import { Col, Modal, Row } from "antd";
import { useLoading } from "components/GlobalLoading/index";
import Field from "components/Input/Field/index";
import InputAutoCompleteCodigoImposto from "components/Input/InputAutoCompleteCodigoImposto/index";
import InputMoney from "components/Input/InputMoney/index";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import SelectNumber from "components/Input/SelectNumber";
import { useDetalheImposto } from "core/features/Imposto/hooks/useDetalheImposto";
import useGetPutImposto from "core/features/Imposto/hooks/useGetPutImposto";
import { ImpostoForm } from "core/features/Imposto/typings";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import SelectPessoas from "ui/components/Input/SelectPessoas";

interface ModalCadastrarImpostoProps {
  open: boolean;
  onClose: () => any;
  id?: string;
  refetchList?: () => any;
}

export default function ModalCadastrarImposto({
  onClose,
  open,
  id,
  refetchList,
}: ModalCadastrarImpostoProps) {
  const { mutate: saveImposto, isLoading: isLoadingSave } = useGetPutImposto(
    id!
  );
  const { data, isLoading } = useDetalheImposto(id);
  const { control, handleSubmit, reset } = useForm<ImpostoForm>();
  const [registerAnother, setRegisterAnother] = useState(false);
  const onSubmit = async (data: ImpostoForm) => {
    saveImposto(data, {
      onSuccess: () => {
        setTimeout(() => {
          if (!registerAnother) {
            onClose();
            showSuccess();
            refetchList?.();
          } else {
            reset({});
            showSuccess();
            refetchList?.();
          }
        }, 200);
      },
      onError: (e) => {
        showErrorAxios(e);
      },
    });
  };

  useEffect(() => {
    if (open) {
      reset(data);
    }
  }, [data, reset, open]);

  useLoading(isLoading || isLoadingSave);

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      destroyOnClose
      width="700px"
      title="Nova Retenção"
      footer={
        <FooterModal
          registerAnother={registerAnother}
          showRegisterAnother={!id}
          setRegisterAnother={setRegisterAnother}
          isLoadingSave={isLoadingSave}
          onClose={onClose}
          onSubmit={handleSubmit(onSubmit)}
        />
      }
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Box as={Row} mb={4} gutter={16}>
          <Col md={12}>
            <Field
              label="Imposto"
              control={control}
              name="nome"
              rules={{
                required: "Campo obrigatório",
              }}
            />
          </Col>
          <Col md={12}>
            <Field
              label="Código"
              control={control}
              name="codigo"
              rules={{
                required: "Campo obrigatório",
              }}
              render={({ field }) => (
                <InputAutoCompleteCodigoImposto
                  onType={field.onChange}
                  textValue={field.value}
                  placeholder=""
                />
              )}
            />
          </Col>
        </Box>
        <Box as={Row} mb={4} gutter={16}>
          <Col md={12}>
            <Field
              label="Aliquota (%)"
              control={control}
              name="aliquota"
              rules={{
                required: "Campo obrigatório",
              }}
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </Col>
          <Col md={12}>
            <Field
              label="Órgão arrecadador"
              control={control}
              name="pessoaArrecadadoraId"
              render={({ field, isInvalid }) => (
                <SelectPessoas
                  {...field}
                  isInvalid={isInvalid}
                  tipoEntidades={[
                    TipoEntidadeEnum.OrgaoPublico,
                    TipoEntidadeEnum.Fornecedor,
                  ]}
                />
              )}
            />
          </Col>
        </Box>
        <Box as={Row} mb={4} gutter={16}>
          <Col md={12}>
            <Field
              label="Conta categoria"
              control={control}
              name="categoriaFinanceiraId"
              render={({ field, isInvalid }) => (
                <SelectContaCategoria
                  disableNotClassifiableNodes
                  placeholder="Selecione"
                  size="large"
                  isInvalid={isInvalid}
                  {...field}
                />
              )}
            />
          </Col>
          <Col md={6}>
            <Field
              label="Conta contábil"
              control={control}
              name="contaContabil"
            />
          </Col>
          <Col md={6}>
            <Field
              label="Vencimento"
              control={control}
              name="vencimento"
              render={({ field }) => (
                <SelectNumber {...field} min={1} max={31} />
              )}
            />
          </Col>
        </Box>
      </form>
    </Modal>
  );
}
